module.exports = __webpack_public_path__ + "img/customer_design_8@2x.2fe586b.jpg";